import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "28",
  fill: "none",
  viewBox: "0 0 24 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FF5100",
      "fill-rule": "evenodd",
      d: "m22.236 20.885.084-.258-1.312-.634 2.209-6.743-2.555.23-1.283-6.315h-2.038L11.608 0 5.875 7.165H3.838L2.555 13.48 0 13.25l2.209 6.743-1.312.634.084.258c1.293 3.963 5.418 6.854 10.309 6.975h.637c4.89-.12 9.015-3.012 10.309-6.975m-10.309 6.347h-.637l-.085-.002.002-5.547-4.48-2.895.476-.715 4.004 2.587v-5.608L6.712 11.87l.506-.694 3.99 2.823V8.645h.868v5.354l3.988-2.823.507.694-4.495 3.182v5.608l4.004-2.587.476.715-4.48 2.895-.002 5.544z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }